import {
  Address,
  GeoCoordinate,
  LocalOfferLocation,
  LocalOfferMarker,
  LocationTypeEnum,
  UpsideOfferDetails,
} from '@varo/graphql-schema-types';

/**
 * Build a LocalOfferLocation from UpsideOfferDetails.mapData and offer metadata.
 * Returns null when mapData is missing.
 */
export function buildLocalOfferLocationFromUpsideDetails(
  offer: UpsideOfferDetails,
): LocalOfferLocation | null {
  if (!offer || !offer.mapData) {
    return null;
  }

  const marker = offer.mapData?.markerLocation;
  const lat = marker?.latitude;
  const lng = marker?.longitude;

  if (
    typeof lat !== 'number' ||
    typeof lng !== 'number' ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    return null;
  }

  const address: Address = {
    __typename: 'Address',
    addressLine1: offer.addressText ?? null,
  };

  const coordinate: GeoCoordinate = {
    __typename: 'GeoCoordinate',
    latitude: offer.mapData.markerLocation.latitude,
    longitude: offer.mapData.markerLocation.longitude,
  };

  const location: LocalOfferLocation = {
    __typename: 'LocalOfferLocation',
    id: `${offer.id}`,
    type: LocationTypeEnum.LocalOffer,
    // TODO: JT-149636 refactor so this is not hardcoded on FE. Upside offers details screen specifies NO Label, and OLD Pin format specifically for details screen only
    name: offer.name,
    address,
    addressCopy: offer.addressText ?? undefined,
    coordinate,
    distance: '',
    marker: offer.marker ?? LocalOfferMarker.Merchant,
    sourceMerchantId: offer.sourceMerchantId ?? undefined,
    cashbackAmount: offer.cashbackAmount ?? undefined,
    industry: offer.industry,
    logoImage: offer.logoImage,
    offerId: offer.id,
    offerType: offer.offerType,
    merchantId: offer.merchantId ?? undefined,
    offerSource: offer.offerSource,
    onClick: {
      __typename: 'RouteNavigationAction',
      route: '',
    },
  };

  return location;
}
